export const directeur = '/positions/f9435fd7-276e-7007-e040-fd0a049a282a';
export const pedagogischVerantwoordelijke = '/positions/7d3b7af1-b46f-46ce-946b-855eafa2899e';
export const coordinator = '/positions/f9435fd7-276c-7007-e040-fd0a049a282a';
export const beheerder = '/positions/eaefae68-c188-4618-98c6-effdd848faa7';
